import React, { Component } from "react";
import List from "./RouteList";
import AddEdit from "./RouteAddEdit";

class Route extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "List") {
      return <List onClick={this.handleClick} />;
    } else {
      return (
        <AddEdit
          pData={this.state.data}
          onClick={this.handleClick}
          source="list"
        />
      );
    }
  }

  handleClick(mode, data) {
    this.setState({ data });
    this.setState({ mode });
  }
}

export default Route;
